import React, { useEffect, useState, useRef } from 'react';
import Select, { SingleValue } from "react-select";
import { SimulatorModel } from '../models/SimulatorModel';
import { useSelector, useDispatch } from 'react-redux';
import '../assets/css/systemManagement.css';
import { ProductionModel } from '../models/ProductionModel';
import TreeView from "./TreeView";

type Option = { value: number; label: string };

const ProductionFilesManagement = () => {
  const simulatorModel: SimulatorModel = new SimulatorModel();

  const [treeData, setTreeData] = useState<any[]>([]);
  const [insuranceCompanyList, setInsuranceCompanyList] = useState<any[]>([]);
  const [insuranceCompany, setInsuranceCompany] = useState<string>("");
  const [files, setFiles] = useState<File[]>([]);
  const [status, setStatus] = useState<string | undefined>(undefined);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth(); // 0-based
  const intervalRef = useRef<NodeJS.Timeout | null>(null); // Store interval ID
  const [year, setYear] = useState<Option>({
    value: currentYear,
    label: currentYear.toString(),
  });

  const [month, setMonth] = useState<Option>({
    value: currentMonth + 1,
    label: new Date(0, currentMonth).toLocaleString("he", { month: "long" }),
  });

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const tree = await new ProductionModel().GetFilesDetails();
    setTreeData(tree);

    const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
    const fixedInsuranceCompanies: any[] = Object.keys(insuranceCompaniesData).map((k: string) => ({
      value: insuranceCompaniesData[k].description,
      label: insuranceCompaniesData[k].name,
    }));
    fixedInsuranceCompanies.sort((a, b) => (a.label > b.label ? 1 : -1));
    setInsuranceCompanyList(fixedInsuranceCompanies);
  };

  const onInsuranceCompanyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInsuranceCompany(e.target.value);
  };

  const onClearInsuranceCompany = () => {
    setInsuranceCompany("");
  };

  // Build year options (current ±2)
  const years = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);
  const yearOptions: Option[] = years.map((year) => ({
    value: year,
    label: year.toString(),
  }));

  // Build month options
  const monthNames = [
    "ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני",
    "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר",
  ];
  const monthOptions: Option[] = monthNames.map((m, i) => ({
    value: i + 1,
    label: m,
  }));

  const handleYearChange = (newValue: SingleValue<Option>) => {
    if (newValue) setYear(newValue);
  };

  const handleMonthChange = (newValue: SingleValue<Option>) => {
    if (newValue) setMonth(newValue);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      // convert FileList to array
      const selectedFiles = Array.from(event.target.files);
      setFiles(selectedFiles);
    }
  };

  const handleUpload = async () => {
    if (files.length === 0) {
      alert("Please select files first.");
      return;
    }

    const formData = new FormData();
    files.forEach((file) => formData.append("Files", file));
    formData.append("InsuranceCompany", insuranceCompany);
    formData.append("Year", year.value + "");
    formData.append("Month", month.value + "");
    startInterval();
    await new ProductionModel().policyReadProductionFile(formData);


  };


  const startInterval = async () => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(async () => {
        var _status = await new ProductionModel().GetProductionStatus();
        setStatus(_status);
        if (_status == "סיום!") {
          stopInterval();
        }

      }, 2000);
      console.log('Interval started');
    }
  };

  const stopInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      console.log('Interval stopped');
    }
  };

  return (
    <div className="main-content rtl content-body leads-list">
      <div>
        <div className="data-card">
          {/* Insurance company */}
          <div className="parameter-item">
            <div className="field">
              <div className="title">חברת ביטוח</div>
              <div className="value">
                <input
                  type="text"
                  list="companies_list"
                  placeholder="בחר חברת ביטוח"
                  onChange={onInsuranceCompanyChange}
                  value={insuranceCompany}
                />
                <datalist id="companies_list">
                  {insuranceCompanyList.map((c, i) => (
                    <option key={i} value={c.label}>
                      {c.label}
                    </option>
                  ))}
                </datalist>
                <div className="icon x-clear pointer" onClick={onClearInsuranceCompany}></div>
              </div>
              <div className="error-message"></div>
            </div>
          </div>

          {/* Year */}
          <div className="parameter-item">
            <div className="field">
              <div className="title">שנה</div>
              <div className="value">
                <Select
                  options={yearOptions}
                  value={year}
                  onChange={handleYearChange}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>

          {/* Month */}
          <div className="parameter-item">
            <div className="field">
              <div className="title">חודש</div>
              <div className="value">
                <Select
                  options={monthOptions}
                  value={month}
                  onChange={handleMonthChange}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>

          {/* File */}
          <div className="parameter-item">
            <div className="field">
              <div className="title">קובץ</div>
              <div className="value">
                <input type="file" multiple onChange={handleFileChange} className="mb-3" />
{status && status.length>0?<>{status}</>:<button
                  onClick={handleUpload}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Upload
                </button>}
                

                {files.length > 0 && (
                  <ul className="mt-3 text-sm text-gray-700 list-disc list-inside">
                    {files.map((file, index) => (
                      <li key={index}>{file.name}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Files */}
        <div className="data-card">
          <div className="data-card-body flex-space-between">
            <div className="p-4">
              <h2 className="text-xl font-bold mb-2">קבצים</h2>
              <TreeView node={treeData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductionFilesManagement;
export { };
